import React from 'react';
import './GenericModal.css'; // Create this CSS file for styling

const GenericModal = ({ isOpen, onClose, title, message, primaryButton, secondaryButton, characterImage }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {characterImage && (
          <img 
            src={characterImage} 
            alt="Character" 
            className="modal-character"
          />
        )}
        <h2>{title}</h2>
        <p>{message}</p>
        <div className="modal-buttons">
          {primaryButton && (
            <button className="modal-primary-btn" onClick={primaryButton.onClick}>
              {primaryButton.label}
            </button>
          )}
          {secondaryButton && (
            <button className="modal-secondary-btn" onClick={secondaryButton.onClick}>
              {secondaryButton.label}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default GenericModal;